var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product_id != "rats"
    ? _c(
        "div",
        {
          staticClass: "contact-us-section",
          attrs: { id: "connectus_div_touchstart" },
          on: {
            touchstart: function($event) {
              return _vm.touchstart($event)
            },
            touchend: function($event) {
              return _vm.touchend($event, 1, "我们的优势")
            }
          }
        },
        [
          _c("div", { staticClass: "flex-h-center" }, [
            _c("div", { staticClass: "slash header mr10" }),
            _vm._v(" "),
            _c("div", { staticClass: "f32 blue-1 light" }, [
              _vm._v(_vm._s(_vm.title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "slash header ml10" })
          ]),
          _vm._v(" "),
          _c(
            "van-swipe",
            {
              staticClass: "slider-wrapper mt32",
              attrs: {
                id: "connectus_van_imgClick_mt32",
                autoplay: 5000,
                loop: true
              },
              on: { change: _vm.imgClick }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "van-swipe-item",
                { key: index, staticClass: "slider-page" },
                [
                  _c("div", { staticClass: "slice left" }, [
                    _c(
                      "div",
                      {
                        staticClass: "diamond",
                        style:
                          _vm.title != "我们的优势"
                            ? "background-color: #ececec;"
                            : "background-color: #fff;"
                      },
                      [
                        _c("img", {
                          staticClass: "bg",
                          attrs: {
                            alt: "拜耳虫虫拜拜 | " + item[0].title,
                            src: require("../assets/img/resources/contact_us/" +
                              item[0].img)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "diamond-desc left" }, [
                      _c("div", { staticClass: "diamond-content" }, [
                        _c(
                          "div",
                          { staticClass: "diamond-content-title bold white" },
                          [_vm._v(_vm._s(item[0].title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "diamond-content-subtitle light white"
                          },
                          [_vm._v(_vm._s(item[0].text))]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "slice right" }, [
                    _c(
                      "div",
                      {
                        staticClass: "diamond",
                        style:
                          _vm.title != "我们的优势"
                            ? "background-color: #ececec;"
                            : "background-color: #fff;"
                      },
                      [
                        _c("img", {
                          staticClass: "bg",
                          attrs: {
                            alt: "拜耳虫虫拜拜 | " + item[1].title,
                            src: require("../assets/img/resources/contact_us/" +
                              item[1].img)
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "diamond-desc right" }, [
                      _c("div", { staticClass: "diamond-content" }, [
                        _c(
                          "div",
                          { staticClass: "diamond-content-title bold white" },
                          [_vm._v(_vm._s(item[1].title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "diamond-content-subtitle light white"
                          },
                          [_vm._v(_vm._s(item[1].text))]
                        )
                      ])
                    ])
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.title != "我们的优势",
                  expression: "title != '我们的优势'"
                }
              ],
              staticClass: "contact-action-wrapper flex-row mt45",
              staticStyle: { position: "relative" }
            },
            [
              _c("div", { staticClass: "diamond-btn-wrapper flex-row" }, [
                _c(
                  "a",
                  {
                    staticClass: "diamond-btn left",
                    staticStyle: { "z-index": "9" },
                    attrs: {
                      id: "connect_a_detailLink_left",
                      href: "javascript:;",
                      "data-fuget": "283"
                    },
                    on: {
                      click: function($event) {
                        return _vm.detailLink()
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "diamond" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.contains.common.personal_service))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "diamond-btn right slash-btn",
                    attrs: {
                      id: "connect_a_utils_right",
                      href: _vm.$rootUrl + "/enterprise",
                      "data-fuget": "283"
                    },
                    on: {
                      click: function($event) {
                        return _vm.utils.ga.cta("Non-Resident")
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "diamond",
                      staticStyle: { "background-color": "#00BCFF" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.contains.common.enterprise_service))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("WeChatCode", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCode1,
                    expression: "showCode1"
                  }
                ],
                staticStyle: { top: "60px", left: "0px" },
                attrs: { product_id: _vm.product_id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              staticClass: "weixin-dialog-img",
              attrs: { title: "", top: "20vh", visible: _vm.weixinDialogImg },
              on: {
                "update:visible": function($event) {
                  _vm.weixinDialogImg = $event
                }
              }
            },
            [
              _vm.codeImg == ""
                ? _c("div", { staticClass: "con" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: require("@/assets/images/newhome/404.png"),
                          expression:
                            "require('@/assets/images/newhome/404.png')"
                        }
                      ],
                      staticStyle: { width: "50%", height: "auto" }
                    }),
                    _vm._v(" "),
                    _c("p", { staticStyle: { color: "#4D4CC1" } }, [
                      _vm._v("服务即将上线，敬请期待")
                    ])
                  ])
                : _c("div", { staticClass: "con" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: require("@/assets/images/newhome/" +
                            _vm.codeImg +
                            ".png"),
                          expression:
                            "require('@/assets/images/newhome/' + codeImg + '.png')"
                        }
                      ]
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("请微信扫码查看相关详情")])
                  ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361f66a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361f66a3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/connect_us.vue
// module id = null
// module chunks = 